(function () {
  var ZOOM_FIELD_DESKTOP = 1.14;
  var ZOOM_RATES_DESKTOP = 1.32;
  var TRANSITION_MS = 680;
  var CURSOR_MOVE_MS = 640;
  var CURSOR_TIP_OFFSET = 4;
  var RATES_LOADING_MS = 1100;
  var TITLE_SELECT_MOVE_MS = 420;
  var TITLE_SELECT_DRAG_MS = 560;
  var TYPE_CHAR_MS = 90;

  function getZoomFieldScale() {
    if (window.matchMedia("(max-width: 480px)").matches) return 1.04;
    if (window.matchMedia("(max-width: 767px)").matches) return 1.08;
    return ZOOM_FIELD_DESKTOP;
  }

  function getZoomRatesScale() {
    if (window.matchMedia("(max-width: 480px)").matches) return 1.06;
    if (window.matchMedia("(max-width: 767px)").matches) return 1.12;
    return ZOOM_RATES_DESKTOP;
  }

  function initRateCityDemo(root) {
    var stage = root.querySelector(".melo-app-rate-city-demo-stage");
    var demoRoot = root.querySelector(".melo-app-rate-city-demo");
    var embedShell = root.querySelector("[data-melo-rate-city-zoom-surface]");
    var citySelect = root.querySelector("[data-melo-rate-city-city]");
    var cityInput = root.querySelector("[data-melo-rate-city-city-input]");
    var cityWrap = root.querySelector("[data-melo-rate-city-city-wrap]");
    var primaryLabel = root.querySelector("[data-melo-rate-city-primary-label]");
    var zipField = root.querySelector("[data-melo-rate-city-zip-field]");
    var zipSelect = root.querySelector("[data-melo-rate-city-zip]");
    var methodsEl = root.querySelector("[data-melo-rate-city-methods]");
    var methodsEmpty = root.querySelector(
      "[data-melo-rate-city-methods-empty]",
    );
    var captionEl = root.querySelector("[data-melo-rate-city-caption]");
    var shippingEl = root.querySelector("[data-melo-rate-city-shipping]");
    var totalEl = root.querySelector("[data-melo-rate-city-total]");
    var cursor = root.querySelector("[data-melo-rate-city-demo-cursor]");
    var takeControlBtn = root.querySelector(
      "[data-melo-rate-city-demo-take-control]",
    );

    if (!stage || !demoRoot || !citySelect || !embedShell || !cityInput) {
      return;
    }

    var instanceId =
      root.getAttribute("data-melo-rate-city-instance") || "default";
    var bentoMode = root.getAttribute("data-melo-rate-city-bento-mode") || "";
    var methodRadioName = "melo-rate-city-method-" + instanceId;
    var isBentoProblem = bentoMode === "problem";
    var isBentoCheckout = bentoMode === "checkout";
    var isBentoStatic = isBentoProblem || isBentoCheckout;

    var subtotal = 29;
    var city = "los-angeles";
    var zip = "90210";
    var ruleSource = "city";
    var cityInputText = "";
    var cityCommitted = false;
    var zipCommitted = false;
    var ratesLoading = false;
    var titleSelectProgress = 0;
    var titleSelectRateIndex = 0;
    var pendingTitleSelect = false;
    var titleSelectionFrame = null;
    var userControlled = false;
    var userInteractionReady = false;
    var playbackActive = false;
    var cursorAnchor = { x: 0, y: 0 };
    var currentZoom = { scale: 1, panX: 0, panY: 0 };
    var playbackTimeouts = [];
    var prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    var copy = {
      cityLabel: "Ciudad",
      zipLabel: "Código postal",
      captionByCity: {
        "los-angeles":
          "En Los Angeles solo aparece la tarifa Envío Los Angeles.",
        "san-francisco":
          "En San Francisco solo aparece la tarifa Envío San Francisco.",
        "san-diego": "En San Diego solo aparece la tarifa Envío San Diego.",
      },
      captionByZip: {
        "90210":
          "En el código postal 90210 solo aparece la tarifa Envío CP 90210.",
        "94102":
          "En el código postal 94102 solo aparece la tarifa Envío CP 94102.",
        "92101":
          "En el código postal 92101 solo aparece la tarifa Envío CP 92101.",
      },
      ratesByCity: {
        "los-angeles": [
          {
            id: "city-la",
            title: "Envío Los Angeles — 2 a 4 días háb.",
            price: "$4.99",
            description:
              "Tarifa configurada solo para compradores en Los Angeles.",
          },
        ],
        "san-francisco": [
          {
            id: "city-sf",
            title: "Envío San Francisco — 1 a 3 días háb.",
            price: "$6.50",
            description:
              "Tarifa configurada solo para compradores en San Francisco.",
          },
        ],
        "san-diego": [
          {
            id: "city-sd",
            title: "Envío San Diego — 2 a 4 días háb.",
            price: "$5.25",
            description:
              "Tarifa configurada solo para compradores en San Diego.",
          },
        ],
      },
      ratesByZip: {
        "90210": [
          {
            id: "zip-90210",
            title: "Envío CP 90210 — 1 a 2 días háb.",
            price: "$14.99",
            description:
              "Tarifa configurada solo para el código postal 90210.",
          },
        ],
        "94102": [
          {
            id: "zip-94102",
            title: "Envío CP 94102 — 3 a 5 días háb.",
            price: "$7.99",
            description:
              "Tarifa configurada solo para el código postal 94102.",
          },
        ],
        "92101": [
          {
            id: "zip-92101",
            title: "Envío CP 92101 — 1 a 2 días háb.",
            price: "$14.99",
            description:
              "Tarifa configurada solo para el código postal 92101.",
          },
        ],
      },
    };

    function clearTimeouts() {
      playbackTimeouts.forEach(function (id) {
        window.clearTimeout(id);
      });
      playbackTimeouts = [];
    }

    function schedule(fn, delay) {
      var id = window.setTimeout(function () {
        if (playbackActive) fn();
      }, delay);
      playbackTimeouts.push(id);
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function parsePrice(value) {
      return parseFloat(String(value).replace(/[^0-9.]/g, "")) || 0;
    }

    function formatMoney(amount) {
      return "$" + amount.toFixed(2);
    }

    function clearDemoFocus() {
      root.querySelectorAll(".is-demo-focus").forEach(function (element) {
        element.classList.remove("is-demo-focus");
      });
    }

    function setDemoFocus(target) {
      clearDemoFocus();
      if (!userControlled) {
        if (target === "cityWrap" && cityWrap) {
          cityWrap.classList.add("is-demo-focus");
          return;
        }
      }
      var element = resolveTarget(target);
      if (element) element.classList.add("is-demo-focus");
    }

    function getBentoProblemRates() {
      return [
        copy.ratesByCity["los-angeles"][0],
        copy.ratesByCity["san-francisco"][0],
        copy.ratesByCity["san-diego"][0],
      ];
    }

    function getRates() {
      if (isBentoProblem) {
        return getBentoProblemRates();
      }
      var hasRatesDisplay = cityCommitted || zipCommitted;
      if (ratesLoading || !hasRatesDisplay) return [];
      var sourceRates =
        ruleSource === "zip"
          ? copy.ratesByZip[zip] || []
          : copy.ratesByCity[city] || [];
      return userControlled || isBentoCheckout
        ? sourceRates
        : sourceRates.slice(0, 1);
    }

    function getCaption() {
      if (isBentoStatic) return "";
      var hasRatesDisplay = cityCommitted || zipCommitted;
      if (!hasRatesDisplay || ratesLoading) return "";
      return ruleSource === "zip"
        ? copy.captionByZip[zip] || ""
        : copy.captionByCity[city] || "";
    }

    function updatePrimaryLabel() {
      if (!primaryLabel || userControlled) {
        if (primaryLabel) primaryLabel.textContent = copy.cityLabel;
        return;
      }
      primaryLabel.textContent =
        ruleSource === "zip" ? copy.zipLabel : copy.cityLabel;
    }

    function measureCursorAnchor() {
      if (!demoRoot || !stage) return;
      var rootRect = demoRoot.getBoundingClientRect();
      var stageRect = stage.getBoundingClientRect();
      cursorAnchor = {
        x:
          stageRect.left -
          rootRect.left +
          stageRect.width / 2 -
          CURSOR_TIP_OFFSET,
        y:
          stageRect.top -
          rootRect.top +
          stageRect.height / 2 -
          CURSOR_TIP_OFFSET,
      };
      if (cursor) {
        cursor.style.setProperty("--cursor-x", cursorAnchor.x + "px");
        cursor.style.setProperty("--cursor-y", cursorAnchor.y + "px");
      }
    }

    function getShellOriginScreen(shell) {
      var parent = shell.parentElement;
      if (!parent) return { x: 0, y: 0 };
      var parentRect = parent.getBoundingClientRect();
      return {
        x: parentRect.left + shell.offsetLeft,
        y: parentRect.top + shell.offsetTop,
      };
    }

    function getTargetLocalInShell(shell, target, zoom) {
      var origin = getShellOriginScreen(shell);
      var targetRect = target.getBoundingClientRect();
      var targetCx = targetRect.left + targetRect.width / 2;
      var targetCy = targetRect.top + targetRect.height / 2;
      var scale = zoom.scale || 1;
      return {
        x: (targetCx - origin.x - zoom.panX) / scale,
        y: (targetCy - origin.y - zoom.panY) / scale,
      };
    }

    function applyZoomState(state) {
      if (!embedShell) return;
      currentZoom = state;
      embedShell.style.setProperty("--rules-pan-x", state.panX + "px");
      embedShell.style.setProperty("--rules-pan-y", state.panY + "px");
      embedShell.style.setProperty("--rules-zoom-scale", String(state.scale));
    }

    function measureFocusOnCenter(element, scale) {
      if (!embedShell || !element || !stage) {
        return { scale: 1, panX: 0, panY: 0 };
      }
      var stageRect = stage.getBoundingClientRect();
      var stageCx = stageRect.left + stageRect.width / 2;
      var stageCy = stageRect.top + stageRect.height / 2;
      var origin = getShellOriginScreen(embedShell);
      var local = getTargetLocalInShell(embedShell, element, currentZoom);
      return {
        scale: scale,
        panX: stageCx - origin.x - local.x * scale,
        panY: stageCy - origin.y - local.y * scale,
      };
    }

    function resolveTarget(target) {
      if (target === "cityWrap") {
        return userControlled ? cityWrap : cityInput || cityWrap;
      }
      if (target === "methods") return methodsEl;
      return null;
    }

    function measureTitleTextRect(titleEl) {
      var textEl = titleEl.querySelector(
        ".melo-app-rate-demo-method-title-base",
      );
      return (textEl || titleEl).getBoundingClientRect();
    }

    function animateTo(target, scale, done) {
      if (target === "methods" || target === "cityWrap") {
        cancelTitleSelection();
        render();
      }
      if (target === "methods") {
        setDemoFocus("methods");
      } else if (target === "cityWrap") {
        setDemoFocus("cityWrap");
      }
      var element = resolveTarget(target);
      if (!element || prefersReducedMotion) {
        applyZoomState({ scale: 1, panX: 0, panY: 0 });
        if (done) done();
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (!playbackActive) return;
          applyZoomState(measureFocusOnCenter(element, scale));
          schedule(function () {
            if (done) done();
          }, TRANSITION_MS);
        });
      });
    }

    function resetView(done) {
      applyZoomState({ scale: 1, panX: 0, panY: 0 });
      schedule(
        function () {
          if (done) done();
        },
        prefersReducedMotion ? 0 : TRANSITION_MS,
      );
    }

    function cancelTitleSelection() {
      if (titleSelectionFrame !== null) {
        window.cancelAnimationFrame(titleSelectionFrame);
        titleSelectionFrame = null;
      }
      titleSelectProgress = 0;
    }

    function renderMethodTitle(title, progress, isPrimary) {
      var attrs = isPrimary ? " data-melo-rate-city-method-title" : "";
      var base =
        '<span class="melo-app-rate-demo-method-title-base">' +
        escapeHtml(title) +
        "</span>";
      if (progress <= 0) {
        return (
          '<span class="melo-app-rate-demo-method-title"' +
          attrs +
          ">" +
          base +
          "</span>"
        );
      }
      return (
        '<span class="melo-app-rate-demo-method-title"' +
        attrs +
        ">" +
        base +
        '<span class="melo-app-rate-demo-method-title-selected" style="clip-path:inset(0 ' +
        (100 - progress) +
        '% 0 0)" aria-hidden="true">' +
        escapeHtml(title) +
        "</span></span>"
      );
    }

    function animateTitleSelection() {
      if (!playbackActive || userControlled) return;

      var titleEl = root.querySelector("[data-melo-rate-city-method-title]");
      if (!titleEl || !demoRoot) return;

      cancelTitleSelection();

      if (prefersReducedMotion) {
        titleSelectProgress = 100;
        render();
        return;
      }

      var rootRect = demoRoot.getBoundingClientRect();
      var textRect = measureTitleTextRect(titleEl);
      var startPoint = {
        x: textRect.left - rootRect.left - CURSOR_TIP_OFFSET,
        y:
          textRect.top - rootRect.top + textRect.height / 2 - CURSOR_TIP_OFFSET,
      };
      var endPoint = {
        x: textRect.right - rootRect.left - CURSOR_TIP_OFFSET,
        y: startPoint.y,
      };

      if (cursor) {
        cursor.style.transitionDuration = TITLE_SELECT_MOVE_MS + "ms";
        cursor.style.setProperty("--cursor-x", startPoint.x + "px");
        cursor.style.setProperty("--cursor-y", startPoint.y + "px");
      }

      schedule(function () {
        if (!playbackActive) return;

        var dragStart = performance.now();

        function tick(now) {
          if (!playbackActive) {
            cancelTitleSelection();
            render();
            return;
          }

          var elapsed = now - dragStart;
          var progress = Math.min(100, (elapsed / TITLE_SELECT_DRAG_MS) * 100);
          var ratio = progress / 100;

          titleSelectProgress = progress;
          if (cursor) {
            cursor.style.transitionDuration = "0ms";
            cursor.style.setProperty(
              "--cursor-x",
              startPoint.x + (endPoint.x - startPoint.x) * ratio + "px",
            );
            cursor.style.setProperty("--cursor-y", startPoint.y + "px");
          }
          render();

          if (progress < 100) {
            titleSelectionFrame = window.requestAnimationFrame(tick);
          } else {
            titleSelectionFrame = null;
          }
        }

        titleSelectionFrame = window.requestAnimationFrame(tick);
      }, TITLE_SELECT_MOVE_MS);
    }

    function renderMethodSkeleton() {
      return (
        '<div class="melo-app-rate-demo-method-skeleton" aria-hidden="true">' +
        '<span class="melo-app-rate-demo-method-skeleton-radio"></span>' +
        '<span class="melo-app-rate-demo-method-skeleton-title"></span>' +
        '<span class="melo-app-rate-demo-method-skeleton-price"></span>' +
        "</div>"
      );
    }

    function render() {
      if (cityInput) cityInput.value = cityInputText;
      updatePrimaryLabel();
      if (zipField) zipField.hidden = !userControlled;

      var rates = getRates();
      var hasRatesDisplay =
        cityCommitted || zipCommitted || isBentoStatic;
      var hasRates = rates.length > 0;
      var showSkeleton = hasRatesDisplay && ratesLoading;

      if (methodsEmpty) methodsEmpty.hidden = hasRatesDisplay || showSkeleton;
      if (methodsEl) {
        methodsEl.hidden = !hasRates && !showSkeleton;
        methodsEl.classList.toggle("is-loading", showSkeleton);
        methodsEl.setAttribute("aria-busy", showSkeleton ? "true" : "false");
      }

      if (methodsEl && showSkeleton) {
        methodsEl.innerHTML = renderMethodSkeleton();
      } else if (methodsEl && hasRates) {
        methodsEl.innerHTML = rates
          .map(function (rate, index) {
            var selected = index === 0;
            return (
              '<label class="melo-app-rate-demo-method' +
              (selected ? " is-selected" : "") +
              '">' +
              '<span class="melo-app-rate-demo-method-control">' +
              '<input type="radio" name="' +
              methodRadioName +
              '" value="' +
              escapeHtml(rate.id) +
              '"' +
              (selected ? " checked" : "") +
              ' tabindex="-1">' +
              '<span class="melo-app-rate-demo-method-radio" aria-hidden="true"></span>' +
              "</span>" +
              '<span class="melo-app-rate-demo-method-copy">' +
              renderMethodTitle(
                rate.title,
                index === titleSelectRateIndex ? titleSelectProgress : 0,
                index === titleSelectRateIndex,
              ) +
              '<span class="melo-app-rate-demo-method-price">' +
              '<span class="melo-app-rate-demo-method-price-value">' +
              escapeHtml(rate.price) +
              "</span></span>" +
              '<span class="melo-app-rate-demo-method-desc">' +
              escapeHtml(rate.description) +
              "</span></span></label>"
            );
          })
          .join("");
      }

      if (hasRates) {
        var amount = parsePrice(rates[0].price);
        if (shippingEl) shippingEl.textContent = rates[0].price;
        if (totalEl) totalEl.textContent = formatMoney(subtotal + amount);
      } else {
        if (shippingEl) shippingEl.textContent = "—";
        if (totalEl) totalEl.textContent = formatMoney(subtotal);
      }

      if (captionEl) {
        var caption = getCaption();
        captionEl.textContent = caption;
        captionEl.hidden = !caption;
      }
    }

    function beginRatesLoad(options) {
      var titleSelect = options && options.titleSelect;
      var source = (options && options.source) || ruleSource;
      cancelTitleSelection();
      if (titleSelect) {
        pendingTitleSelect = true;
      }
      ruleSource = source;
      if (source === "zip") {
        zipCommitted = true;
        cityCommitted = false;
      } else {
        cityCommitted = true;
        zipCommitted = false;
      }
      titleSelectRateIndex = 0;
      ratesLoading = true;
      render();
      var loadId = window.setTimeout(function () {
        ratesLoading = false;
        render();
      }, RATES_LOADING_MS);
      playbackTimeouts.push(loadId);
    }

    function setCity(nextCity, options) {
      city = nextCity;
      beginRatesLoad(Object.assign({ source: "city" }, options || {}));
      if (citySelect) citySelect.value = nextCity;
      render();
    }

    function setZip(nextZip, options) {
      zip = nextZip;
      beginRatesLoad(Object.assign({ source: "zip" }, options || {}));
      if (zipSelect) zipSelect.value = nextZip;
      render();
    }

    function closeMenus() {
      clearDemoFocus();
    }

    function runStepSequence(steps, done) {
      function runStep(index) {
        if (!playbackActive) return;
        var step = steps[index];
        if (!step) {
          if (done) done();
          return;
        }
        if (step.kind === "wait") {
          schedule(function () {
            runStep(index + 1);
          }, step.ms);
          return;
        }
        if (step.kind === "focus") {
          animateTo(step.target, step.scale, function () {
            runStep(index + 1);
          });
          return;
        }
        if (step.kind === "reset") {
          resetView(function () {
            moveCursorToStageCenter(function () {
              runStep(index + 1);
            });
          });
          return;
        }
        if (step.kind === "switchToZip") {
          cancelTitleSelection();
          ruleSource = "zip";
          cityCommitted = false;
          zipCommitted = false;
          ratesLoading = false;
          cityInputText = "";
          render();
          schedule(function () {
            runStep(index + 1);
          }, prefersReducedMotion ? 120 : 180);
          return;
        }
        if (step.kind === "titleSelect") {
          if (!pendingTitleSelect) {
            runStep(index + 1);
            return;
          }
          pendingTitleSelect = false;

          function runWhenReady() {
            if (!playbackActive) return;
            if (ratesLoading) {
              schedule(runWhenReady, 50);
              return;
            }
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                if (!playbackActive) return;
                animateTitleSelection();
                var holdMs = prefersReducedMotion
                  ? 400
                  : TITLE_SELECT_MOVE_MS + TITLE_SELECT_DRAG_MS + 400;
                schedule(function () {
                  runStep(index + 1);
                }, holdMs);
              });
            });
          }

          runWhenReady();
          return;
        }
        if (step.kind === "type") {
          runTypeStep(step, index + 1);
          return;
        }
        clickTarget(step.target, function () {
          schedule(
            function () {
              runStep(index + 1);
            },
            prefersReducedMotion ? 0 : 120,
          );
        });
      }

      function runTypeStep(step, nextIndex) {
        var text = step.text;

        function finishTyping() {
          if (step.action) step.action();
          schedule(
            function () {
              runStep(nextIndex);
            },
            prefersReducedMotion ? 0 : 120,
          );
        }

        if (step.clearFirst) {
          cityInputText = "";
          render();
        }

        if (prefersReducedMotion) {
          cityInputText = text;
          render();
          finishTyping();
          return;
        }

        var charIndex = 0;
        function typeNextChar() {
          charIndex += 1;
          cityInputText = text.slice(0, charIndex);
          render();
          if (charIndex < text.length) {
            schedule(typeNextChar, TYPE_CHAR_MS);
          } else {
            finishTyping();
          }
        }

        schedule(typeNextChar, TYPE_CHAR_MS);
      }

      runStep(0);
    }

    function runPlaybackSequence() {
      if (!playbackActive || userControlled) return;

      var reduced = prefersReducedMotion;
      var zoomField = getZoomFieldScale();
      var zoomRates = getZoomRatesScale();
      runStepSequence(
        [
          { kind: "wait", ms: reduced ? 900 : 700 },
          { kind: "focus", target: "cityWrap", scale: zoomField },
          { kind: "click", target: "cityWrap" },
          {
            kind: "type",
            target: "cityWrap",
            text: "San Francisco",
            action: function () {
              setCity("san-francisco", { titleSelect: true });
            },
          },
          { kind: "wait", ms: reduced ? 400 : 480 },
          { kind: "focus", target: "methods", scale: zoomRates },
          { kind: "titleSelect" },
          { kind: "wait", ms: reduced ? 700 : 900 },
          { kind: "focus", target: "cityWrap", scale: zoomField },
          { kind: "click", target: "cityWrap" },
          {
            kind: "type",
            target: "cityWrap",
            text: "San Diego",
            clearFirst: true,
            action: function () {
              setCity("san-diego", { titleSelect: true });
            },
          },
          { kind: "wait", ms: reduced ? 400 : 480 },
          { kind: "focus", target: "methods", scale: zoomRates },
          { kind: "titleSelect" },
          { kind: "wait", ms: reduced ? 700 : 900 },
          { kind: "switchToZip" },
          { kind: "wait", ms: reduced ? 500 : 600 },
          { kind: "focus", target: "cityWrap", scale: zoomField },
          { kind: "click", target: "cityWrap" },
          {
            kind: "type",
            target: "cityWrap",
            text: "90210",
            clearFirst: true,
            action: function () {
              setZip("90210", { titleSelect: true });
            },
          },
          { kind: "wait", ms: reduced ? 400 : 480 },
          { kind: "focus", target: "methods", scale: zoomRates },
          { kind: "titleSelect" },
          { kind: "wait", ms: reduced ? 700 : 900 },
          { kind: "reset" },
          { kind: "wait", ms: reduced ? 700 : 900 },
        ],
        function () {
          cityCommitted = false;
          zipCommitted = false;
          ratesLoading = false;
          ruleSource = "city";
          city = "los-angeles";
          zip = "90210";
          cityInputText = "";
          render();
          moveCursorToStageCenter(runPlaybackSequence);
        },
      );
    }

    function getCursorPointForElement(element) {
      var rootRect = demoRoot.getBoundingClientRect();
      var rect = element.getBoundingClientRect();
      return {
        x: rect.left - rootRect.left + rect.width / 2 - CURSOR_TIP_OFFSET,
        y: rect.top - rootRect.top + rect.height / 2 - CURSOR_TIP_OFFSET,
      };
    }

    function setCursorPosition(point, transitionMs) {
      if (!cursor) return;
      cursor.style.transitionDuration = transitionMs + "ms";
      cursor.style.setProperty("--cursor-x", point.x + "px");
      cursor.style.setProperty("--cursor-y", point.y + "px");
    }

    function moveCursorTo(target, done) {
      var element = resolveTarget(target);
      if (!element || prefersReducedMotion) {
        setDemoFocus(target);
        if (done) done();
        return;
      }
      clearDemoFocus();
      window.requestAnimationFrame(function () {
        setCursorPosition(getCursorPointForElement(element), CURSOR_MOVE_MS);
        schedule(function () {
          setDemoFocus(target);
          if (done) done();
        }, CURSOR_MOVE_MS);
      });
    }

    function moveCursorToStageCenter(done) {
      measureCursorAnchor();
      if (cursor) cursor.style.transitionDuration = CURSOR_MOVE_MS + "ms";
      schedule(
        function () {
          if (done) done();
        },
        prefersReducedMotion ? 0 : CURSOR_MOVE_MS,
      );
    }

    function clickTarget(target, done) {
      clearDemoFocus();
      moveCursorTo(target, function () {
        if (!cursor || prefersReducedMotion) {
          schedule(function () {
            if (done) done();
          }, 120);
          return;
        }
        cursor.style.transitionDuration = "80ms";
        schedule(function () {
          cursor.classList.add("is-clicking");
          schedule(function () {
            cursor.classList.remove("is-clicking");
            if (done) done();
          }, 180);
        }, 90);
      });
    }

    function stopPlayback(options) {
      var preserveRates = options && options.preserveRates;
      playbackActive = false;
      clearTimeouts();
      cancelTitleSelection();
      closeMenus();
      clearDemoFocus();
      if (cursor) {
        cursor.classList.remove("is-clicking");
      }
      applyZoomState({ scale: 1, panX: 0, panY: 0 });
      if (!preserveRates) {
        cityCommitted = false;
        zipCommitted = false;
        ratesLoading = false;
        ruleSource = "city";
      }
      render();
      if (takeControlBtn) takeControlBtn.hidden = true;
      stage.removeAttribute("data-melo-rate-demo-autoplay");
    }

    function startPlayback() {
      if (playbackActive || userControlled) return;
      playbackActive = true;
      stage.setAttribute("data-melo-rate-demo-autoplay", "");
      if (takeControlBtn) takeControlBtn.hidden = false;
      cityCommitted = false;
      zipCommitted = false;
      ratesLoading = false;
      ruleSource = "city";
      city = "los-angeles";
      zip = "90210";
      cityInputText = "";
      applyZoomState({ scale: 1, panX: 0, panY: 0 });
      measureCursorAnchor();
      if (cursor) cursor.classList.add("is-visible");
      render();
      runPlaybackSequence();
    }

    function initUserInteraction() {
      if (userInteractionReady) return;
      userInteractionReady = true;
      closeMenus();

      if (citySelect) {
        citySelect.hidden = false;
        citySelect.removeAttribute("aria-hidden");
        citySelect.tabIndex = 0;
        citySelect.addEventListener("change", function () {
          setCity(citySelect.value);
        });
      }

      if (zipSelect && zipField) {
        zipField.hidden = false;
        zipSelect.hidden = false;
        zipSelect.removeAttribute("aria-hidden");
        zipSelect.tabIndex = 0;
        zipSelect.addEventListener("change", function () {
          setZip(zipSelect.value);
        });
      }
    }

    function enableUserControl() {
      if (userControlled) return;
      userControlled = true;
      stopPlayback({ preserveRates: true });
      if (citySelect) citySelect.value = city;
      if (zipSelect) zipSelect.value = zip;
      render();
      stage.setAttribute("data-melo-rate-demo-user-controlled", "");
      initUserInteraction();
    }

    if (takeControlBtn) {
      takeControlBtn.addEventListener("click", function (event) {
        event.preventDefault();
        enableUserControl();
      });
    }

    function initBentoStaticDemo() {
      if (takeControlBtn) takeControlBtn.hidden = true;
      if (cursor) cursor.style.display = "none";
      stage.classList.add("melo-app-rate-city-demo-stage--bento-static");
      stage.setAttribute("data-melo-rate-city-bento-mode", bentoMode);

      city = "los-angeles";
      cityInputText = "Los Angeles";
      cityCommitted = true;
      zipCommitted = false;
      ruleSource = "city";
      ratesLoading = false;

      if (citySelect) citySelect.value = city;
      if (primaryLabel) primaryLabel.textContent = copy.cityLabel;

      measureCursorAnchor();
      render();
    }

    window.addEventListener("resize", measureCursorAnchor);

    if (isBentoStatic) {
      initBentoStaticDemo();
      return;
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (userControlled) return;
            if (entry.isIntersecting) startPlayback();
            else stopPlayback();
          });
        },
        { threshold: 0.35 },
      );
      observer.observe(stage);
    } else {
      startPlayback();
    }

    measureCursorAnchor();
    render();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll("[data-melo-rate-city-demo]")
      .forEach(initRateCityDemo);
  });
})();
